"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorDeleteConstraint = exports.editorModifyConstraint = exports.editorAddConstraint = exports.editorDeleteColumn = exports.editorModifyColumn = exports.editorAddColumn = exports.fillEditorColumnInfo = void 0;
const v1_1 = __importDefault(require("uuid/v1"));
const omit_1 = __importDefault(require("lodash/omit"));
const lodash_1 = __importDefault(require("lodash"));
function fillEditorColumnInfo(column, table) {
    var _a, _b;
    return Object.assign({ isPrimaryKey: !!((_b = (_a = table === null || table === void 0 ? void 0 : table.primaryKey) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.find(x => x.columnName == column.columnName)), dataType: lodash_1.default.isEmpty(column) ? 'int' : undefined }, column);
}
exports.fillEditorColumnInfo = fillEditorColumnInfo;
function processPrimaryKey(table, oldColumn, newColumn) {
    if (!(oldColumn === null || oldColumn === void 0 ? void 0 : oldColumn.isPrimaryKey) && (newColumn === null || newColumn === void 0 ? void 0 : newColumn.isPrimaryKey)) {
        let primaryKey = table === null || table === void 0 ? void 0 : table.primaryKey;
        if (!primaryKey) {
            primaryKey = {
                constraintType: 'primaryKey',
                pureName: table.pureName,
                schemaName: table.schemaName,
                columns: [],
            };
        }
        return Object.assign(Object.assign({}, table), { primaryKey: Object.assign(Object.assign({}, primaryKey), { columns: [
                    ...primaryKey.columns,
                    {
                        columnName: newColumn.columnName,
                    },
                ] }) });
    }
    if ((oldColumn === null || oldColumn === void 0 ? void 0 : oldColumn.isPrimaryKey) && !(newColumn === null || newColumn === void 0 ? void 0 : newColumn.isPrimaryKey)) {
        let primaryKey = table === null || table === void 0 ? void 0 : table.primaryKey;
        if (primaryKey) {
            primaryKey = Object.assign(Object.assign({}, primaryKey), { columns: table.primaryKey.columns.filter(x => x.columnName != oldColumn.columnName) });
            if (primaryKey.columns.length == 0) {
                return Object.assign(Object.assign({}, table), { primaryKey: null });
            }
            return Object.assign(Object.assign({}, table), { primaryKey });
        }
    }
    return table;
}
function editorAddColumn(table, column) {
    let res = Object.assign(Object.assign({}, table), { columns: [...((table === null || table === void 0 ? void 0 : table.columns) || []), Object.assign(Object.assign({}, column), { pairingId: (0, v1_1.default)() })] });
    res = processPrimaryKey(res, null, column);
    return res;
}
exports.editorAddColumn = editorAddColumn;
function editorModifyColumn(table, column) {
    var _a;
    const oldColumn = (_a = table === null || table === void 0 ? void 0 : table.columns) === null || _a === void 0 ? void 0 : _a.find(x => x.pairingId == column.pairingId);
    let res = Object.assign(Object.assign({}, table), { columns: table.columns.map(col => (col.pairingId == column.pairingId ? (0, omit_1.default)(column, ['isPrimaryKey']) : col)) });
    res = processPrimaryKey(res, fillEditorColumnInfo(oldColumn, table), column);
    return res;
}
exports.editorModifyColumn = editorModifyColumn;
function editorDeleteColumn(table, column) {
    let res = Object.assign(Object.assign({}, table), { columns: table.columns.filter(col => col.pairingId != column.pairingId) });
    res = processPrimaryKey(res, column, null);
    return res;
}
exports.editorDeleteColumn = editorDeleteColumn;
function editorAddConstraint(table, constraint) {
    const res = Object.assign({}, table);
    if (constraint.constraintType == 'primaryKey') {
        res.primaryKey = Object.assign({ pairingId: (0, v1_1.default)() }, constraint);
    }
    if (constraint.constraintType == 'foreignKey') {
        res.foreignKeys = [
            ...(res.foreignKeys || []),
            Object.assign({ pairingId: (0, v1_1.default)() }, constraint),
        ];
    }
    if (constraint.constraintType == 'index') {
        res.indexes = [
            ...(res.indexes || []),
            Object.assign({ pairingId: (0, v1_1.default)() }, constraint),
        ];
    }
    if (constraint.constraintType == 'unique') {
        res.uniques = [
            ...(res.uniques || []),
            Object.assign({ pairingId: (0, v1_1.default)() }, constraint),
        ];
    }
    return res;
}
exports.editorAddConstraint = editorAddConstraint;
function editorModifyConstraint(table, constraint) {
    const res = Object.assign({}, table);
    if (constraint.constraintType == 'primaryKey') {
        res.primaryKey = Object.assign(Object.assign({}, res.primaryKey), constraint);
    }
    if (constraint.constraintType == 'foreignKey') {
        res.foreignKeys = table.foreignKeys.map(fk => fk.pairingId == constraint.pairingId ? Object.assign(Object.assign({}, fk), constraint) : fk);
    }
    if (constraint.constraintType == 'index') {
        res.indexes = table.indexes.map(fk => (fk.pairingId == constraint.pairingId ? Object.assign(Object.assign({}, fk), constraint) : fk));
    }
    if (constraint.constraintType == 'unique') {
        res.uniques = table.uniques.map(fk => (fk.pairingId == constraint.pairingId ? Object.assign(Object.assign({}, fk), constraint) : fk));
    }
    return res;
}
exports.editorModifyConstraint = editorModifyConstraint;
function editorDeleteConstraint(table, constraint) {
    const res = Object.assign({}, table);
    if (constraint.constraintType == 'primaryKey') {
        res.primaryKey = null;
    }
    if (constraint.constraintType == 'foreignKey') {
        res.foreignKeys = table.foreignKeys.filter(x => x.pairingId != constraint.pairingId);
    }
    if (constraint.constraintType == 'index') {
        res.indexes = table.indexes.filter(x => x.pairingId != constraint.pairingId);
    }
    if (constraint.constraintType == 'unique') {
        res.uniques = table.uniques.filter(x => x.pairingId != constraint.pairingId);
    }
    return res;
}
exports.editorDeleteConstraint = editorDeleteConstraint;
